import { ICountryData } from '@core/domain-classes/country';

export function getAzureStreetAddress(
  address: ICountryData | null | undefined
): string | null {
  if (!address?.azureAddress1) {
    return address?.azureAddress2 || null;
  }

  return address.azureAddress1.split(',')[0]?.trim() || address.azureAddress2 || null;
}
